var _path, _circle, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12,7.015h0c2.279,0,4.13,1.851,4.13,4.13h0c0,2.279-1.851,4.13-4.13,4.13h-4.13v-4.13c0-2.279,1.851-4.13,4.13-4.13Z",
    transform: "translate(-4.366 11.749) rotate(-45)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.145,
    r: 1.409
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.614,
    y: 2.614,
    width: 18.771,
    height: 18.771,
    rx: 4.188,
    ry: 4.188
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset);
export default __webpack_public_path__ + "static/media/asset.c5627df6c99d2557debbcabb19f0a030.svg";
export { ForwardRef as ReactComponent };